import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, filter, switchMap } from 'rxjs/operators';
import { HttpErrorService } from '../services/http-error.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private httpErrorService = inject(HttpErrorService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return (
      next
        .handle(req)
        .pipe(
          filter(
            (event: HttpEvent<unknown>): event is HttpResponse<{ code: string; message: string }> =>
              event instanceof HttpResponse
          ),
          switchMap((res: HttpResponse<{ code: string; message: string }>) => {
            // TODO: refine this to catch all possible errors
            if (req.url.startsWith(environment.api) && res.body && res.body.code && res.body.message) {
              return throwError(() => res.body);
            }
            return of(res);
          })
        )
        // .pipe(catchError((res: HttpErrorResponse) => throwError(res.error)));
        // .pipe(catchError((res: HttpErrorResponse | HttpResponse<any>) => this.httpErrorService.handleError(res, req.url)));
        .pipe(catchError((res: HttpErrorResponse) => this.httpErrorService.handleError(res, req.url)))
    );
  }
}
